import { forwardRef, type SelectHTMLAttributes } from 'react';

export const nativeSelectClassName =
  'block min-h-11 w-full appearance-none rounded-lg border border-line bg-paper-soft px-3 py-2 pr-10 text-sm text-ink shadow-[inset_0_1px_0_rgba(255,255,255,0.4)] outline-none transition focus:border-ochre focus:ring-2 focus:ring-ochre/30 disabled:cursor-not-allowed disabled:bg-paper-deep disabled:opacity-70';

export interface NativeSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  wrapperClassName?: string;
}

export const NativeSelect = forwardRef<HTMLSelectElement, NativeSelectProps>(function NativeSelect(
  { className, wrapperClassName, children, ...props },
  ref,
) {
  return (
    <span className={classNames('relative block', wrapperClassName)}>
      <select ref={ref} className={classNames(nativeSelectClassName, className)} {...props}>
        {children}
      </select>
      <span
        aria-hidden="true"
        className="pointer-events-none absolute right-3 top-1/2 h-2 w-2 -translate-y-1/2 rotate-45 border-b border-r border-ink-muted"
      />
    </span>
  );
});

function classNames(...values: Array<string | undefined>): string {
  return values.filter(Boolean).join(' ');
}
